import React from 'react';
import { Box } from '@mui/material';
import Reveal from './Reveal';
import { BP, LANDING_FONT, LC, MAXW, MOTION, PAD_X, r } from './landingTokens';

const ITEMS = [
  'Founded by a pharmacist with a PhD in nutrition',
  'No ads. No sponsored products.',
  'Your data stays private — never sold',
];

const Check = () => (
  <Box component="svg" width={16} height={16} viewBox="0 0 14 14" aria-hidden="true" sx={{ flex: 'none' }}>
    <path d="M3 7.4l2.6 2.6L11 4.6" fill="none" stroke={LC.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Box>
);

export default function TrustBar() {
  return (
    <Box component="section" aria-label="Why you can trust myStack" sx={{ background: LC.surface, borderBottom: `${r(1)} solid ${LC.border}`, display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: MAXW,
          px: PAD_X,
          display: 'grid',
          gridTemplateColumns: '1fr',
          [BP.tablet]: { gridTemplateColumns: 'repeat(3, 1fr)' },
        }}
      >
        {ITEMS.map((t, i) => (
          <Reveal
            key={t}
            delay={i * MOTION.stagger}
            repeat
            sx={{
              px: r(24),
              py: r(20),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: r(9),
              textAlign: 'center',
            }}
          >
            <Check />
            {/* One-line lock only at the wide breakpoint, where the longest
                item fits its column. Below that, an unconditional nowrap
                forces the grid track past the viewport — on a 360px Android
                the page rendered 408px wide (prod bug). Text must never be
                allowed to set the page width; Android font scaling grows
                every rem without growing the screen, so no fixed budget
                survives it either. */}
            <Box component="span" sx={{ fontFamily: LANDING_FONT, fontWeight: 700, fontSize: r(14.5), letterSpacing: '-0.01em', color: LC.ink, [BP.wide]: { whiteSpace: 'nowrap' } }}>
              {t}
            </Box>
          </Reveal>
        ))}
      </Box>
    </Box>
  );
}
